import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { mockKPIData } from '../../containers/process-analysis-v2/mocks/kpi-data.mock';
import type {
  ComparisonMode,
  ProcessAnalysisFilters,
  Tab,
  ViewMode,
} from '../../containers/process-analysis-v2/process-analysis-v2.type';
import { isLoggingEnabled, logger } from '../logger/logger';
import type { State } from './process-analysis-store-v2.type';

const initialState = {
  activeTab: 'portfolios' as Tab,
  viewMode: 'measure_comparison' as ViewMode,
  comparisonMode: 'single' as ComparisonMode,
  dateRange: {
    startDate: '2024-06-03',
    endDate: '2024-06-17',
  },
  filters: {
    timeMetrics: ['lead_time', 'reaction_time', 'cycle_time', 'review_time'],
    performanceMetrics: [],
    taskProcessMetrics: [],
    qualityMetrics: [],
    consistencyMetrics: [],
    complexityStrategy: [],
    dependencyIndependence: [],
  } as ProcessAnalysisFilters,
  kpiData: mockKPIData,
  chartData: null,
  isKPILoading: false,
  isChartLoading: false,
  comparisonTarget: null,
  showFilters: true,
};

const useProcessAnalysisStore = create<State>()(
  devtools(
    persist(
      logger((_) => ({
        ...initialState,
      })),
      {
        name: 'process-analysis-v2-storage',
        storage: createJSONStorage(() => localStorage),
        partialize: (state) =>
          Object.fromEntries(
            Object.entries(state).filter(
              ([key]) => !['isKPILoading', 'isChartLoading', 'setShowFilters'].includes(key),
            ),
          ),
      },
    ),
    {
      name: 'Bloomfilter - Process Analysis V2 Store',
      enabled: isLoggingEnabled,
    },
  ),
);

export { initialState, useProcessAnalysisStore };
